export default {
  modal: {
    title: 'Bulk Approve',
    content: 'Approve jobs for selected %jobsCount% Wonoloers?',
  }
};
